module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'page-fixed-height': !_vm.activePanel
    }
  }, [_c('div', {
    staticClass: "sideways-page-one",
    class: {
      'disabled': !_vm.activePanel
    }
  }, [_c('div', {
    staticClass: "page-bar"
  }, [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.breadcrumbArray
    }
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("UNOgames")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn blue btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.throttledCreate()
      }
    }
  }, [_vm._v("Create a New Campaign")]), _vm._v(" "), _c('div', {
    staticClass: "margin-top-20"
  }, [_c('div', {
    staticClass: "relative-block"
  }, [_c('loading-screen', {
    attrs: {
      "show": _vm.loadingCampaignData,
      "color": '#3598dc',
      "display": 'inline'
    }
  }), _vm._v(" "), (_vm.loadingCampaignData === false) ? _c('div', [_c('div', {
    staticClass: "clearfix"
  }, [_c('dropdown', [_c('button', {
    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
    attrs: {
      "slot": "button",
      "type": "button",
      "data-toggle": "dropdown"
    },
    slot: "button"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCampaign Status"), _c('b', [_vm._v(": " + _vm._s(_vm.advancedSearch.status))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "dropdown-menu"
    },
    slot: "dropdown-menu"
  }, [_c('li', {
    class: {
      'active': _vm.advancedSearch.status === 'all'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setSearchStatus('all')
      }
    }
  }, [_vm._v("All")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.advancedSearch.status === 'running'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setSearchStatus('running')
      }
    }
  }, [_vm._v("Running")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.advancedSearch.status === 'pending'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setSearchStatus('pending')
      }
    }
  }, [_vm._v("Pending")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.advancedSearch.status === 'paused'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setSearchStatus('paused')
      }
    }
  }, [_vm._v("Paused")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.advancedSearch.status === 'expired'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setSearchStatus('expired')
      }
    }
  }, [_vm._v("Expired")])])])]), _vm._v(" "), _c('dropdown', [_c('button', {
    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
    attrs: {
      "slot": "button",
      "type": "button",
      "data-toggle": "dropdown"
    },
    slot: "button"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCampaign Type"), _c('b', [_vm._v(": " + _vm._s(_vm.advancedSearch.type))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "dropdown-menu"
    },
    slot: "dropdown-menu"
  }, [_c('li', {
    class: {
      'active': _vm.advancedSearch.status === 'all'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setSearchType('all')
      }
    }
  }, [_vm._v("All")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.advancedSearch.status === 'ig'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setSearchType('ig')
      }
    }
  }, [_vm._v("Instagage")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.advancedSearch.status === 'sw'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setSearchType('sw')
      }
    }
  }, [_vm._v("Scratch To Win")])])])]), _vm._v(" "), _c('page-results', {
    staticClass: "pull-right",
    attrs: {
      "totalResults": _vm.totalResults,
      "activePage": _vm.activePage
    },
    on: {
      "pageResults": _vm.pageResultsUpdate
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-top-20"
  }, [_c('pagination', {
    attrs: {
      "passedPage": _vm.activePage,
      "numPages": _vm.numPages
    },
    on: {
      "activePageChange": _vm.activePageUpdate
    }
  })], 1), _vm._v(" "), (_vm.numPages !== 0) ? _c('div', {
    staticClass: "margin-top-20 unogames-table"
  }, [_c('div', [_c('table', {
    staticClass: "table table-hover"
  }, [_c('tbody', [_vm._l((_vm.campaigns), function(campaign) {
    return [_c('tr', [_c('td', {
      staticClass: "unogames-table-column-icon"
    }, [(campaign.campaign_type === 'sw') ? _c('i', {
      staticClass: "fa fa-lg fa-star-half-o"
    }) : _vm._e(), _vm._v(" "), (campaign.campaign_type === 'ig') ? _c('i', {
      staticClass: "fa fa-lg fa-instagram"
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "unogames-table-column"
    }, [_c('p', [_vm._v(_vm._s(campaign.name))]), _vm._v(" "), _c('p', {
      staticClass: "font-grey-cascade font-12"
    }, [_vm._v("Created by: N/A")]), _vm._v(" "), _c('p', {
      staticClass: "font-grey-cascade font-12"
    }, [_vm._v("Created on: N/A")])]), _vm._v(" "), _c('td', {
      staticClass: "unogames-table-column"
    }, [_c('div', {
      staticClass: "uno-progress-bar"
    }, [_c('div', {
      style: (("width: " + (_vm.calculateProgressWidth(campaign))))
    })]), _vm._v(" "), _c('p', {
      staticClass: "font-12"
    }, [_vm._v("Starts: " + _vm._s(_vm.filterDateString(campaign.starts_at)))]), _vm._v(" "), _c('p', {
      staticClass: "font-grey-cascade font-12"
    }, [_vm._v("Ends: " + _vm._s(_vm.filterDateString(campaign.ends_at)))])]), _vm._v(" "), _c('td', {
      staticClass: "unogames-table-column-icon"
    }, [_c('dropdown', [_c('button', {
      staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
      attrs: {
        "slot": "button",
        "type": "button",
        "data-toggle": "dropdown"
      },
      slot: "button"
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu",
      attrs: {
        "slot": "dropdown-menu"
      },
      slot: "dropdown-menu"
    }, [_c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.editCampaignDetails(campaign.id)
        }
      }
    }, [_vm._v("Edit Campaign Details")])]), _vm._v(" "), _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.editContestDesign(campaign.id)
        }
      }
    }, [_vm._v("Edit Contest Layout")])]), _vm._v(" "), (campaign.campaign_type === 'sw') ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.editContestPrizes(campaign.id)
        }
      }
    }, [_vm._v("Edit Contest Prizes")])]) : _vm._e(), _vm._v(" "), (campaign.campaign_type === 'sw') ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.editSkillTestingQuestions(campaign.id)
        }
      }
    }, [_vm._v("Edit Skill Testing Questions")])]) : _vm._e()])]), _vm._v(" "), (campaign.status === 'pending') ? _c('i', {
      staticClass: "fa fa-play clickable",
      on: {
        "click": function($event) {
          _vm.updateStatus(campaign, 'running')
        }
      }
    }) : _vm._e(), _vm._v(" "), (campaign.status !== 'pending') ? _c('i', {
      staticClass: "fa fa-pause clickable",
      on: {
        "click": function($event) {
          _vm.updateStatus(campaign, 'pending')
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fa fa-line-chart clickable"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-trash-o clickable",
      on: {
        "click": function($event) {
          _vm.deleteCampaignConfirmation(campaign)
        }
      }
    })], 1)])]
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('no-results', {
    attrs: {
      "show": _vm.numPages === 0,
      "type": 'campaigns'
    }
  }), _vm._v(" "), _c('pagination', {
    attrs: {
      "passedPage": _vm.activePage,
      "numPages": _vm.numPages
    },
    on: {
      "activePageChange": _vm.activePageUpdate
    }
  })], 1) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "sideways-page-two",
    class: {
      'active': !_vm.activePanel, 'inactive': _vm.activePanel, 'full-width-content-fold': _vm.$route.name === 'UNOgames - Edit Contest Layout'
    },
    style: ({
      height: _vm.computedHeight
    })
  }, [_c('div', {
    staticClass: "sideways-blank-fold"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn blue btn-lg margin-bottom-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePanel()
      }
    }
  }, [_vm._v("Return to this page")])])]), _vm._v(" "), _c('create-campaign'), _vm._v(" "), _c('edit-campaign-details'), _vm._v(" "), _c('edit-contest-layout'), _vm._v(" "), _c('edit-contest-prizes'), _vm._v(" "), _c('edit-skill-testing-questions')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note note-info"
  }, [_c('p', [_vm._v("Create and manage all UNOgames campaigns.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09512d4c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/UNOgames.vue
// module id = 403
// module chunks = 1